import React, {  useEffect } from "react";
import { Col, Modal, ModalBody, Row, ModalHeader, Card, CardBody } from "reactstrap";
// Redux
import { useSelector, useDispatch } from "react-redux";

import { casosDetallesFilter } from "../../../../store/casosDetalles/actions";

const CasosDesplazVer = ({ verModal, onCloseClick, Item }) => {
  const URL = process.env.REACT_APP_API_URL.split("/api").join("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(casosDetallesFilter(`get_gestiones_caso/?caso=${Item.id}`));
  }, [dispatch, Item.id]);

  const foto =
    Item.images && Item.images.length > 0
      ? Item.images.map((image) => image)
      : [];

  console.log(foto);

  console.log(Item)

  const handleButtonClick = () => {
    onCloseClick(); // Llama a la función onCloseClick pasada como prop desde el componente padre
  };


  const gestionesCaso = useSelector(
    (state) => state.CasosDetalles.casosDetalles
  );

  console.log(gestionesCaso)
  return (
    <React.Fragment>
      <Modal isOpen={verModal} toggle={onCloseClick} centered={true} size="lg">
        <ModalHeader toggle={handleButtonClick} tag="h4">
          Caso Desplazamiento
        </ModalHeader>

        <ModalBody>
          {foto.length !== 0 ? (
            <div style={{ display: "flex" }}>
              {foto.map((image, index) => (
                <img
                  key={index}
                  src={`${URL}/media/${image}`}
                  alt=""
                  style={{
                    display: "block",
                    margin: "0 auto",
                    border: "2px dashed",
                    width: "150px",
                  }}
                />
              ))}
            </div>
          ) : null}



<Row className="justify-content-center">
                    <Col xl={10}>
                      <div className="timeline">
                        <div className="timeline-item timeline-left">
                          <div className="timeline-block">
                            <div className="time-show-btn mt-0">
                            
                            </div>
                          </div>
                        </div>
                        {Array.isArray(gestionesCaso)
                          ? gestionesCaso.map((item, index) => {
                              const timelineItemClass =
                                index % 2 === 0
                                  ? "timeline-item"
                                  : "timeline-item timeline-left";

                              console.log(item.fecha_asignar);
                              return (
                                <div
                                  className={timelineItemClass}
                                  key={item.id}
                                >
                                  <div className="timeline-block">
                                    <Card className="timeline-box">
                                      <CardBody>
                                        <span className="timeline-icon"></span>

                                        {item.fecha_asignar !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_asignar.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_asignar.substring(
                                                  10
                                                )}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Asignar</p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Tecnico Asignado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.tecnico_asignado}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Observacion
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.observaciones}
                                              </p>
                                            </div>
                                          </>
                                        ) : item.fecha_aceptar !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_aceptar.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_aceptar.substring(
                                                  10
                                                )}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Aceptar</p>
                                            </div>
                                          </>
                                        ) : item.fecha_iniciar !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_iniciar.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_iniciar.substring(
                                                  10
                                                )}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Iniciar</p>
                                            </div>
                                          </>
                                        ) : item.fecha_pausa !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_pausa.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_pausa.substring(10)}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Pausar</p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Observacion
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">{item.observaciones}</p>
                                            </div>
                                          </>
                                        ) : item.fecha_reanudar !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_reanudar.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_reanudar.substring(
                                                  10
                                                )}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Reanudar</p>
                                            </div>
                                          </>
                                        ) : item.fecha_finalizar !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_finalizar.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_finalizar.substring(
                                                  10
                                                )}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Finalizar</p>
                                            </div>
                                          </>
                                        ) : item.fecha_finalizar === "" &&
                                          item.fecha_asignar === "" &&
                                          item.fecha_aceptar === "" &&
                                          item.fecha_iniciar === "" &&
                                          item.fecha_pausa === "" &&
                                          item.fecha_reanudar === "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.created_date}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0"></p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Observacion
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.observaciones}
                                              </p>
                                            </div>
                                          </>
                                        ) : null}
                                      </CardBody>
                                    </Card>
                                  </div>
                                </div>
                              );
                            })
                          : []}
                      </div>
                    </Col>
                  </Row>
        </ModalBody>

        {/* Botones de abajo */}
        <Row>
          <Col>
            <div className="text-end">
              <button
                type="button"
                className="btn btn-light me-2"
                onClick={handleButtonClick}
              >
                Close
              </button>
            </div>
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default CasosDesplazVer;
